import service from '@/base/service'
const baseURL = process.env.VUE_APP_BASE_API_AI
const request = (data) => {
  return service({ ...data, ...{ baseURL } })
}
// export function proximity (postData) {
//   return request({
//     url: 'map/proximity',
//     method: 'POST',
//     data: postData
//   })
// }
// 商机地图查询附近公司 - HID
export function proximity (postData) {
  return request({
    url: 'vv5/map/proximity',
    method: 'POST',
    data: postData
  })
}

export function getContactInfo (data) {
  return request({
    url: 'map/getContactInfo',
    method: 'get',
    params: data
  })
}